<template>
  <v-layout row wrap>
    <template v-for="(item, index) in items">
      <v-flex :xs6="$vuetify.breakpoint.lgOnly"
              :xs4="$vuetify.breakpoint.xlOnly"
              :pa-1="$vuetify.breakpoint.lgAndUp"
              :py-1="$vuetify.breakpoint.mdAndDown"
              :xs12="$vuetify.breakpoint.mdAndDown"
              :key="index" v-if="!item.items">
        <v-card class="pa-0 ma-0 elevation-1" :id="`card-${item.itemId}`" @mouseenter="cardElevate(item.itemId)"
                style="height: 100%"
                @mouseleave="cardDeElevate(item.itemId)">
          <v-img v-if="isImage(item, 'webshop-itemlist-banner')"
                 class="imageBannerClass"
                 :src="env === 'development' ? `/api/imageresource/${item.images.filter(x => x.label === 'webshop-itemlist-banner')[0].value}`
             : `/webshopplanet/imageresource/${item.images.filter(x => x.label === 'webshop-itemlist-banner')[0].value}`">
          </v-img>
          <v-layout justify-start
                    row wrap
                    class="cursorHand py-0 px-2" style="overflow: hidden !important; height: 100%">
            <v-flex xs2 v-if="isImage(item, 'webshop-itemlist-icon')" style="min-width: 25px; max-width: 50px; min-height: 50px; max-height: 50px">
              <v-img contain
                     class="imageIconClass"
                     :src="env === 'development' ? `/api/imageresource/${item.images.filter(x => x.label === 'webshop-itemlist-icon')[0].value}`
                         : `/webshopplanet/imageresource/${item.images.filter(x => x.label === 'webshop-itemlist-icon')[0].value}`"
              >
              </v-img>
            </v-flex>
            <v-flex :xs12="!isImage(item, 'webshop-itemlist-icon')" style="width: calc(100% - 50px)">
              <v-layout row wrap :py-2="!isImage(item, 'webshop-itemlist-icon')" pl-2 style="height: 100%">
                <v-flex xs12 style="height: 46px" @click="allergensDialog ? '' : $emit('openItem', item)">
                  <div>
                    <v-layout row wrap justify-space-between style="position: relative">
                    <span style="float: left; padding-top: 4px; margin-right: 20px;"
                          :class="{ 'mb-1': !!item.desc && item.desc.en, 'mb-0': !item.desc || !item.desc.en, 'textItem': isImage(item, 'webshop-itemlist-icon') }">
                      {{ item.name[$lang.current_lang] ? item.name[$lang.current_lang] : item.name.en }}
                    </span>
                      <i class="desc bi-info-circle" style="position: absolute; right: -2px; top: 2px" :style="goDark ? 'color: #ffffffb3' : ''"
                         @click.prevent="allergensDialog = true; $emit('openItem', {...item, shouldOpenModal: true})">
                      </i>
                    </v-layout>
                    <span class="d-inline-flex" @click="$emit('openItem', item)">
                        <span><v-img v-if="isImage(item, 'webshop-itemlist-postsymbol1')"
                                     contain
                                     class="imageIconClassSmall"
                                     :src="env === 'development' ? `/api/imageresource/${item.images.filter(x => x.label === 'webshop-itemlist-postsymbol1')[0].value}`
                         : `/webshopplanet/imageresource/${item.images.filter(x => x.label === 'webshop-itemlist-postsymbol1')[0].value}`"
                        >
                      </v-img></span>
                      <span class="pl-1"><v-img v-if="isImage(item, 'webshop-itemlist-postsymbol2')"
                                                contain
                                                class="imageIconClassSmall"
                                                :src="env === 'development' ? `/api/imageresource/${item.images.filter(x => x.label === 'webshop-itemlist-postsymbol2')[0].value}`
                         : `/webshopplanet/imageresource/${item.images.filter(x => x.label === 'webshop-itemlist-postsymbol2')[0].value}`"
                      >
                      </v-img></span>
                        <span class="pl-1"><v-img v-if="isImage(item, 'webshop-itemlist-postsymbol3')"
                                                  contain
                                                  class="imageIconClassSmall"
                                                  :src="env === 'development' ? `/api/imageresource/${item.images.filter(x => x.label === 'webshop-itemlist-postsymbol3')[0].value}`
                         : `/webshopplanet/imageresource/${item.images.filter(x => x.label === 'webshop-itemlist-postsymbol3')[0].value}`"
                        >
                      </v-img></span>
                      </span>
                  </div>
                </v-flex>
                <v-flex :xs9="isImage(item, 'webshop-itemlist-icon')" :xs12="!isImage(item, 'webshop-itemlist-icon')" @click="$emit('openItem', item)" :style="`transform: translate(0, ${isImage(item, 'webshop-itemlist-icon') ? '-25px' : '0'})`">
                  <p :style="goDark ? 'color: #ffffffb3' : ''" :class="{'mb-0 desc': true,  'px-0': isImage(item, 'webshop-itemlist-icon'), 'px-2': !isImage(item, 'webshop-itemlist-icon')}" v-if="item.desc && item.desc[$lang.current_lang]">{{
                      item.desc[$lang.current_lang] ?
                          item.desc[$lang.current_lang] : item.desc.en
                    }}</p>
                  <p class="mb-0 pl-3" v-else>&nbsp;</p>
                </v-flex>
                <v-flex :grow="isImage(item, 'webshop-itemlist-icon')" :xs12="!isImage(item, 'webshop-itemlist-icon')" class="text-xs-right" @click="$emit('openItem', item)" :style="`transform: translate(0, ${isImage(item, 'webshop-itemlist-icon') ? '-25px' : '0'})`">
                  <div class="text-xs-right">
                    <span :style="goDark ? 'color: #ffffffb3' : ''" class="mr-2 price" v-if="!isNaN(item.price) && !item.shouldOpenModal">
                      {{ company ? company.currencySymbol : '' }}{{ item.price.toFixed(2) }}
                    </span>
                    <v-btn
                        dark
                        small
                        color="accent"
                        flat
                        data-add="addFood"
                        class="mx-0 my-btn my-0 elevation-0">
                      <v-icon :class="item.shouldOpenModal ? 'addWithOptions' : 'add'" dark>
                        {{ item.shouldOpenModal ? 'view_module' : 'add' }}
                      </v-icon>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-layout row wrap px-3 v-if="item.items && item.items.length > 0" style="width: 100%">
        <v-flex xs12>
          <Categories @success="flashSuccess" :itemsList="items.filter(x => x.items && x.itemId === item.itemId)"
                      :nested="true"/>
        </v-flex>
      </v-layout>
    </template>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';

export default {

  props: ['items', 'env', 'nested'],
  data: () => ({
    companyId: null,
    allergensDialog: false,
    allergens: [],
  }),
  computed: mapGetters({
    company: 'company',
    catalog: 'catalog',
    width: 'width',
    goDark: 'goDark',
  }),
  watch: {
    allergensDialog() {
      setTimeout(() => {
        if (this.allergensDialog) this.allergensDialog = false;
      }, 100);
    },
  },
  created() {
    this.companyId = localStorage.getItem('webShopResourceId');
  },
  methods: {
    flashSuccess(event) {
      this.$emit('success', event);
    },
    openAllergens(allergens) {
      this.allergens = allergens;
      this.allergensDialog = true;
    },
    closeDialog() {
      this.allergens = [];
      this.allergensDialog = false;
    },
    cardElevate(index) {
      const el = document.getElementById(`card-${index}`);
      el.classList.remove('elevation-1');
      el.classList.add('elevation-6');
    },
    cardDeElevate(index) {
      const el = document.getElementById(`card-${index}`);
      el.classList.remove('elevation-6');
      el.classList.add('elevation-1');
    },
    isImage(item, label) {
      if (item.images) {
        return item.images.filter(x => x.label === label).length > 0;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.price {
  vertical-align: middle;
}

.v-table__overflow {
  height: 102px !important;
}

.desc {
  min-width: 1px;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  color: rgba(0, 0, 0, 0.5);
}

@media only screen and (min-width: 600px) {
  .theme--light {
    .table {
      background-color: transparent !important;
    }
  }
}

.cursorHand {
  cursor: pointer;
}

.imageIconClass {
  max-width: 50px;
  max-height: 50px;
  border-radius: 3px;
  padding-top: 8px;
}

.imageIconClassSmall {
  min-width: 25px;
  max-width: 25px;
  max-height: 25px;
  border-radius: 3px;
}

.imageBannerClass {
  border-radius: 3px;
  max-height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/webshop/Items.vue